import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("kd_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default api;

export const auth = {
  register: (payload) => api.post("/auth/register", payload).then((r) => r.data),
  login: (payload) => api.post("/auth/login", payload).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
};

export const projects = {
  create: (payload) => api.post("/projects", payload).then((r) => r.data),
  get: (id) => api.get(`/projects/${id}`).then((r) => r.data),
  update: (id, payload) => api.patch(`/projects/${id}`, payload).then((r) => r.data),
  list: () => api.get("/projects").then((r) => r.data),
  claim: (id) => api.post(`/projects/${id}/claim`).then((r) => r.data),
  generate: (id) => api.post(`/projects/${id}/generate`).then((r) => r.data),
  status: (id) => api.get(`/projects/${id}/status`).then((r) => r.data),
  pdfUrl: (id) => `${API}/projects/${id}/pdf`,
  revise: (id, page_id, instructions) => api.post(`/projects/${id}/revise`, { page_id, instructions }).then((r) => r.data),
  graphics: (id) => api.post(`/projects/${id}/graphics`).then((r) => r.data),
  share: (id, enabled, password, custom_slug) => api.post(`/projects/${id}/share`, { enabled, password, custom_slug }).then((r) => r.data),
};

export const publicDeck = {
  get: (token, password) => api.get(`/public/deck/${token}`, { params: password ? { password } : {} }).then((r) => r.data),
  pdfUrl: (token, password) => `${API}/public/deck/${token}/pdf${password ? `?password=${encodeURIComponent(password)}` : ""}`,
};

export const ai = {
  enhance: (text, tone, creator_type) => api.post("/ai/enhance", { text, tone, creator_type }).then((r) => r.data),
  concepts: (project_id) => api.post("/ai/concepts", { project_id }).then((r) => r.data),
  suggestPages: (project_id) => api.post("/ai/suggest-pages", { project_id }).then((r) => r.data),
};

export const templates = {
  list: () => api.get("/templates").then((r) => r.data),
  apply: (project_id, slug) => api.post(`/projects/${project_id}/apply-template`, { slug }).then((r) => r.data),
};

export const upload = {
  images: (files) => {
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));
    return api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};

export const payments = {
  checkout: (lookup_key, project_id, quantity = 1) =>
    api.post("/payments/checkout", { lookup_key, project_id, quantity, origin_url: window.location.origin }).then((r) => r.data),
  status: (session_id) => api.get(`/payments/status/${session_id}`).then((r) => r.data),
};

export const admin = {
  settings: () => api.get("/admin/settings").then((r) => r.data),
  updateSettings: (payload) => api.patch("/admin/settings", payload).then((r) => r.data),
  orders: () => api.get("/admin/orders").then((r) => r.data),
  users: () => api.get("/admin/users").then((r) => r.data),
  projects: () => api.get("/admin/projects").then((r) => r.data),
  assign: (id) => api.post(`/admin/projects/${id}/assign`).then((r) => r.data),
  stats: () => api.get("/admin/stats").then((r) => r.data),
  supportThreads: () => api.get("/admin/support/threads").then((r) => r.data),
  supportThread: (id) => api.get(`/admin/support/threads/${id}`).then((r) => r.data),
  supportReply: (id, text) => api.post(`/admin/support/threads/${id}/reply`, { text }).then((r) => r.data),
  supportResolve: (id) => api.post(`/admin/support/threads/${id}/resolve`).then((r) => r.data),
};

export const config = {
  get: () => api.get("/config").then((r) => r.data),
};
